var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScoreIconsRp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.82 16.6035L13.0018 0L1.18359 16.6271L7.89569 26.4997V18.0891C7.89569 17.5486 8.36921 17.1093 8.95096 17.1093C9.53272 17.1093 10.0062 17.5486 10.0062 18.0891V29.6031L13.0026 33.9993L24.82 16.6035Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29688 15.9773L13.0093 2.3125L22.6357 15.837L13.0093 6.82019L3.29688 15.9773Z",
    fill: "#FF6500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.29688 15.9754L13.0093 2.31055L22.6357 15.8351L13.0093 6.81823L3.29688 15.9754Z",
    fill: "#FEC800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0093 28.6425V11.2246L20.5013 17.6114L18.374 20.7406C18.5539 20.937 18.6629 21.1917 18.6629 21.4701V23.2857L22.7065 17.3375L13.0093 9.07227L3.29688 17.3375L6.53195 22.0962V18.0891C6.53195 16.8442 7.61827 15.8349 8.95846 15.8349C10.2987 15.8349 11.385 16.8442 11.385 18.0891V29.2339L13.0101 31.6129L16.2372 26.8542V23.8838L13.0093 28.6425Z",
    fill: "#FEC800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0117 11.2246V28.6433L16.2388 23.8845V21.4701C16.2388 20.8477 16.7816 20.3434 17.4517 20.3434C17.8218 20.3434 18.1528 20.4977 18.3757 20.7413L20.5029 17.6122L13.0117 11.2246Z",
    fill: "#FEE332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreIconsRp);
export default __webpack_public_path__ + "static/media/ScoreIconsRP.fccd7c0b05ec3d95aef2f816e0357cd7.svg";
export { ForwardRef as ReactComponent };